module.exports = __webpack_public_path__ + "static/img/pdf.9869f746.png";